interface PreviewInteractionHintProps {
  text?: string;
}

const DEFAULT_TEXT = "Drag to rotate • Pinch to zoom";

export function PreviewInteractionHint({ text = DEFAULT_TEXT }: PreviewInteractionHintProps) {
  return (
    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-white/20 text-white text-[10px] sm:text-sm px-2.5 sm:px-4 py-1 sm:py-2 rounded-full backdrop-blur-sm whitespace-nowrap">
      {text}
    </div>
  );
}
